module.exports = __webpack_public_path__ + "../resources/images/fileType_sprite-e5e32bbd80bbf1aa37c187ed35b41c5f.png";